export const blockIconsCommonactionsBookmarkNew = (
	<span className='material-symbols-outlined'>bookmark</span>
);
